export default "__VITE_ASSET__DMhE5H4b__"